import { createSlice } from "@reduxjs/toolkit";
import { fetchImageData } from "./browserLessImageThunk";

const initialState = {
  imageBinaryData: '',
  imageStatus: '',
  isLoading: false,
  error: null,
  title: '',
  description: '',
};

const browserLessImageSlice = createSlice({
  name: 'browserLessImage',
  initialState,
  reducers: {
    resetImageData: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchImageData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.imageBinaryData = '';
        state.imageStatus = '';
        state.title = '';
        state.description = '';
      })
      .addCase(fetchImageData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.imageBinaryData = action.payload.imageBinaryData || '';
        state.imageStatus = action.payload.imageStatus;
        state.title = action.payload.title;
        state.description = action.payload.description;
      })
      .addCase(fetchImageData.rejected, (state, action) => {
        state.isLoading = false;
        state.imageStatus = action.payload?.imageStatus || 'Error';
        state.error = action.error.message;
      });
  },
});

export const { resetImageData } = browserLessImageSlice.actions;

export default browserLessImageSlice.reducer;
